export const getFiles = (files, file) => {
  const selectFiles = Object.values(file);
  return [...files, selectFiles].flat();
};

export const getNames = (files, file) => {
  const selectFiles = Object.values(file).map((a) => a?.name);
  return [...files, selectFiles].flat();
};
